export const CoursesMixin = {
    methods:{
      //metodo per selezionare il corso da visualizzare nel dettaglio
        selectCourse(courseID, status, name) { //usato in Home e Courses
            const course = {
              id: courseID,
              courseName: name,
              status: status
            };
            this.$store.dispatch("setCourse", course);
            this.$router.push("/courses/" + courseID);
          }
    }
}

